import React, { useEffect } from 'react';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import ErrorOrMain from './Main';
import Authenticating from 'app/pages/Auth/Authenticating';
import { loginRequest } from 'app/auth/authConfig';
import RouteChangeListener from 'app/shared/pageSystem/RouteChangeListener';
import DivisionWatcher from 'app/shared/ui/DivisionWatcher';

const MainWrapper: React.FC = () => {
    const { instance, inProgress, accounts } = useMsal();
    const isAuthenticated = useIsAuthenticated();

    // setActiveAccount does not trigger a re-render, so assign during render when accounts are known.
    if (accounts.length > 0 && !instance.getActiveAccount()) {
        instance.setActiveAccount(accounts[0]);
    }

    const hasActiveAccount = !!instance.getActiveAccount();

    // Automatically trigger login if not authenticated
    useEffect(() => {
        if (!isAuthenticated && inProgress === InteractionStatus.None) {
            instance.loginRedirect(loginRequest);
        }
    }, [isAuthenticated, inProgress, instance]);

    if (inProgress !== InteractionStatus.None) {
        const status = inProgress === InteractionStatus.Login ? 'Logging in...' : 'Authenticating...';
        return <Authenticating status={status} />;
    }

    if (!isAuthenticated || !hasActiveAccount) {
        return <Authenticating status="Authenticating..." />;
    }

    return (
        <>
            <RouteChangeListener />
            <DivisionWatcher />
            <ErrorOrMain />
        </>
    );
};

export default MainWrapper;